import AppCatalog from "../../services/App/AppCatalog.js";

export default {
  Section: {
    RelatedDetails: {
      Title: AppCatalog.Info.Shop
    }
  }
}